module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDMwIDMwIj4NCiAgPHBhdGggaWQ9Ikljb25fZmVhdGhlci1lZGl0LTIiIGRhdGEtbmFtZT0iSWNvbiBmZWF0aGVyLWVkaXQtMiIgZD0iTTIzLjQyNSw0LjM4NWEzLjg1MSwzLjg1MSwwLDAsMSw1LjQ0Nyw1LjQ0N0wxMC40ODksMjguMjE1LDMsMzAuMjU3bDIuMDQzLTcuNDg5WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEuNSAtMS43NTcpIiBmaWxsPSJub25lIiBzdHJva2U9IiMwMDAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIzIi8+DQo8L3N2Zz4NCg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/pen-icons.svg
// module id = 225
// module chunks = 1